<!-- TEMPLATE -->
<template>
    <div :class='customerDetailsClass'>
        <dean-three-column-layout>
            <div class="column" slot="left">
                <quote-services
                        :quoteId="quoteId"
                        :service="service"
                        :divider="'Diensten'"
                        @update="selectService"
                        :title="serviceMenuTitle ? serviceMenuTitle : 'Versie'"
                ></quote-services>
            </div>
            <div class="column" slot="center">
                <dean-section-title
                        v-if="!service"
                        content="true">
                    <span slot="title">Selecteer een dienst...</span>
                </dean-section-title>
                <quote-service
                        v-if="service"
                        :customer="customerId"
                        :quote="quoteId"
                        :service="service"
                        :status="status"
                        @updateService="updateService"
                        @removeService="removeService"
                ></quote-service>

            </div>
            <div class="column" slot="right">
                <quote-summary
                  :quoteId.sync="quoteId"
                  :customerId="customerId"
                  :partnerId="partnerId"
                  :trigger="trigger"
                  :quoteNumber="number"
                ></quote-summary>
            </div>
        </dean-three-column-layout>
    </div>
</template>

<!-- SCRIPT -->

<script lang='ts'>
  // VUE
  import {Component, Vue} from 'vue-property-decorator';
  import axios from 'axios';

  import {deanDialogBus} from '@/main';
  import QuoteServices from '@/components/quote/services.vue';
  import QuoteSummary from '@/components/quote/summary.vue';
  import QuoteService from '@/components/quote/service.vue';
  import {
    usersIcon,
    partnerIcon,
    invoicesIcon,
    deanLoadOverlay,
    archiveIcon,
    deanCloudIcon,
    offerIcon,
    deanInternetIcon,
    deanMobileIcon,
    deanIcon,
    warningIcon,
  } from '@deanone/dean-components';
  import statusIcon from '@/assets/svg/status.svg';
  import DeanThreeColumnLayout from '@/components/deanComponents/deanThreeColumnLayout.vue';
  import DeanSectionTitle from '@/components/deanComponents/deanSectionTitle.vue';
  import {checkPrivileges} from '@/store/menu/actions';
  import {getErrorMessageFromQuoteCreationProcess} from '@/mixins/quoteCreationExceptionHandler';

  @Component({
    components: {
      DeanSectionTitle,
      deanCloudIcon,
      offerIcon,
      deanInternetIcon,
      deanMobileIcon,
      archiveIcon,
      QuoteServices,
      QuoteSummary,
      QuoteService,
      DeanThreeColumnLayout,
      deanIcon,
      usersIcon,
      partnerIcon,
      statusIcon,
      invoicesIcon,
      deanLoadOverlay,
      warningIcon,
    },
  })
  export default class Details extends Vue {
    public showSomething: boolean = false;
    public archiveIcon: object = archiveIcon;
    public service: any = false;
    public timeout?: number;
    public sideMenu: any = {};
    public quoteId: string = '';
    public transactionId: string = '';
    public customerId: string = '';
    public partnerId: string = '';
    public trigger: number = 0;
    public quoteResponse: any;
    public sideMenuResponse: any;
    public serviceData: any = {};
    public addresses: any = {};
    public serviceMenuTitle: string = '';
    public status: string = '';
    public number: string = '';
    private readonly baseUrl: string = '/-/trade/api/quote.details';
    private readonly removeServiceUrl: string = '/-/trade/api/quote.service.remove';

    // COMPUTED
    public findWithAttr(array: [], attr: string, value: any) {
      for (let i = 0; i < array.length; i += 1) {
        if (array[i][attr] === value) {
          return i;
        }
      }
      return -1;
    }

    public selectService(service: string) {
      this.service = service;
      this.updateService();
    }

    public removeService(location?: string|null) {
      deanDialogBus.$emit('open', 'QuoteRemoveServiceDialog', {
        id: this.$route.params.id,
        service: this.service,
        location,
      });
    }

    public updateService() {
      this.trigger++;
    }

    get customerDetailsClass() {
      let value = 'customer-add';
      if (this.showSomething) {
        value += ' no-scroll-container';
      }
      return value;
    }

    public buildSideMenu(data: any) {
      let sideMenuItems = {
        customer: {
          title: 'Klant(' + data.data.customer.name + ')',
          icon: usersIcon,
          name: 'customers.edit',
          privileges: ['update-customer'],
          params: {
            id: data.data.customer.id,
            paid: '',
          },
        },
        partner: {
          title: 'Partner(' + data.data.partner.name + ')',
          icon: partnerIcon,
          name: 'partners.edit',
          privileges: ['update-partner'],
          params: {
            pid: data.data.partner.id,
            paid: data.data.partner.paid,
          },
        },
        status: {
          title: data.data.status,
          icon: statusIcon,
          privileges: [],
        },
      };

      sideMenuItems = checkPrivileges(this.$store, sideMenuItems);

      this.sideMenu = {
        content: {
          title: {
            text: 'Offerte ' + data.data.number,
            mobile: {
              close: {
                text: 'Close',
                icon: invoicesIcon,
              },
            },
          },
          type: 'themed',
          sections: {
            general: {
              title: 'Algemeen',
              items: sideMenuItems,
            },
          },
        },
      };

      this.$store.dispatch('updateSideMenu', this.sideMenu);
    }

    public created() {
      deanDialogBus.$off('QuoteFinalize');
      deanDialogBus.$on('QuoteFinalize', (payload: { id: string; dataWasSent: boolean }) => {
        this.refresh(true, payload && payload.dataWasSent === true);
      });
      deanDialogBus.$on('QuoteRefresh', () => {
        this.service = null;
        this.trigger++;
      });
      this.refresh();
    }

    private refresh(dialog: boolean = false, dataWasSent: boolean = false) {
      this.quoteId = this.$route.params.id;

      axios.post(this.baseUrl, {id: this.quoteId}).then(
        (response) => {
          this.transactionId = response.data.data.transactionId;
          this.number = response.data.data.number;
          this.buildSideMenu(response.data);
          this.customerId = response.data.data.customer.id;
          this.partnerId = response.data.data.partner.id;
          this.status = response.data.data.status;
          // if status is not 'Concept' this is no longer a quote
          // if status is 'Lost' then quote is lost
          // if status is 'Gewonnen' then quote is an order
          this.serviceMenuTitle = 'Versie ' + response.data.data.version;
          if (this.status === 'Gewonnen') {
            deanDialogBus.$emit('close');
            this.$router.push({name: 'orders.orderlines', params: {
              transactionId: this.transactionId,
            }});
            // next line will cause a lot of errors but it is needed to updated main menu
            // this.$store.dispatch('requestHeader');
          }

          if (dialog && this.status !== 'Gewonnen' && dataWasSent) {
            const error = getErrorMessageFromQuoteCreationProcess(response.data);

            if (null === error) {
              this.$toast({
                icon: warningIcon,
                text: String(this.$t('messages.orderNotCreated')),
                theme: 'warning',
              });
            }
          }
        },
        (error) => {
          // tslint:disable-next-line:no-console
          console.error(error);
        },
      );
    }
  }
</script>

<!-- STYLE -->

<style lang='scss' scoped>
    @import '~@deanone/dean-components/src/scss/vars';

    .component-fade-enter-active, .component-fade-leave-active {
        transition: opacity .3s ease;
    }

    .column {
      padding-bottom: 80px;
    }
</style>
